import { render, staticRenderFns } from "./PowerDataBase.vue?vue&type=template&id=13c11c47&scoped=true&"
import script from "./PowerDataBase.vue?vue&type=script&lang=js&"
export * from "./PowerDataBase.vue?vue&type=script&lang=js&"
import style0 from "./PowerDataBase.vue?vue&type=style&index=0&id=13c11c47&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c11c47",
  null
  
)

export default component.exports